import {
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import {
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_ENTITY_SERVICE,
  SoftlineEntityService,
  Store,
  StoreModule,
} from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import {
  SOFTLINE_API_AKTIVITAETEN,
  SOFTLINE_API_PRUEFPROTOKOLL,
} from './pruefprotokoll.api';
import {
  SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL,
  SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL_AKTIVITAETEN,
  SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL_ERSTELLEN,
  SOFTLINE_PERMISSION_PRUEFPROTOKOLL,
} from './pruefprotokoll.shared';
import { PruefprotokollService } from './services/pruefprotokoll.service';
import { PruefprotokollStore } from './store';
import { AktivitaetenStore } from './store/aktivitaeten.store';
import { PruefprotokollErstellenStore } from './store/pruefprotokoll-erstellen.store';
import { pruefprotokollRoutes } from './pruefprotokoll.routes';
import { providePruefprotokollGlobals } from './pruefprotokoll.globals';

export function providePruefprotokollModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'produktion-pruefprotokoll',
        title: 'Prüfprotokoll',
        icon: 'fa-regular fa-list-check',
        route: '/pruefprotokoll',
        permission: SOFTLINE_PERMISSION_PRUEFPROTOKOLL,
        group: getModuleGroupByName('Produktion'),
      },
      withSoftAppsModuleRoutes({ app: pruefprotokollRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
    ...providePruefprotokollGlobals(),
  ];
}

export const pruefprotokollProviders = [
  importProvidersFrom(
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL,
      feature: PruefprotokollStore.feature,
      providers: [
        {
          provide: SOFTLINE_STORE_ENTITY_SERVICE,
          useFactory: () =>
            new SoftlineEntityService(
              inject(SOFTLINE_SERVICE_HTTP),
              SOFTLINE_API_PRUEFPROTOKOLL
            ),
        },
      ],
    }),
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL_AKTIVITAETEN,
      feature: AktivitaetenStore.feature,
      providers: [
        {
          provide: SOFTLINE_STORE_ENTITY_SERVICE,
          useFactory: () =>
            new SoftlineEntityService(
              inject(SOFTLINE_SERVICE_HTTP),
              SOFTLINE_API_AKTIVITAETEN
            ),
        },
      ],
    }),
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL_ERSTELLEN,
      feature: PruefprotokollErstellenStore.feature,
      providers: [
        {
          provide: PruefprotokollService,
          useFactory: () => new PruefprotokollService(inject(SOFTLINE_SERVICE_HTTP)),
        },
      ],
    })
  ),
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'produktion-pruefprotokoll',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Prüfprotokoll',
      icon: 'fa-regular fa-list-check',
      route: '/pruefprotokoll',
      permission: SOFTLINE_PERMISSION_PRUEFPROTOKOLL,
      group: getModuleGroupByName('Produktion'),
    });
  }),
];
